import icon from '@shared/assets/images/logo-dark-bg.png'
import { BrowserNotification } from '@shared/utils/models/enums'

// storing the value in-memory according to the requirement to request permission on each page reload
let isPermissionRequestedOnce = false

export const showBrowserNotification = (
  title: string,
  body?: string,
  options?: { silent?: boolean; navigate?: () => void }
) => {
  if (!('Notification' in window)) {
    return
  }

  const sendNotification = () => {
    // eslint-disable-next-line no-console
    console.log('BROWSER NOTIFICATION - going to show notification')
    const notification = new Notification(title, {
      body,
      icon,
      silent: !!options?.silent,
    })

    notification.onclick = function () {
      window.focus()
      options?.navigate?.()
      this.close()
    }
  }

  if (Notification.permission === BrowserNotification.Granted) {
    return sendNotification()
  }

  if (!isPermissionRequestedOnce) {
    // eslint-disable-next-line no-console
    console.log('BROWSER NOTIFICATION - going to request permission')
    Notification.requestPermission(function (permission) {
      if (permission === BrowserNotification.Granted) {
        sendNotification()
      }
    })
    isPermissionRequestedOnce = true
  } else {
    // eslint-disable-next-line no-console
    console.log(
      'BROWSER NOTIFICATION - permission is not granted and has already been requested once'
    )
  }
}
